export function getTimes(startTime, interval, length, startingOffset = 0) {
  const times = [];

  for (let offset = startingOffset; offset < startingOffset + length; offset += interval) {
    times.push({
      offset,
      time: startTime.plusMinutes(offset)
    });
  }

  return times;
}
